import React, { createRef, useEffect } from 'react';
import { OtpInput } from './OtpInput';
import './OtpInputContainer.css';

const OtpInputContainer = ({
  otpCode,
  setOtpCode,
  onComplete = () => { },
  otpError,
  length = 6,
  patternPerBox = /\d/,
}) => {
  const otpInputs = Array.from({ length }, () => createRef(null));

  useEffect(() => {
    if (otpCode.length === length) {
      onComplete(otpCode);
    }
  }, [length, onComplete, otpCode]);

  const handleChange = (index) => (event) => {
    const { target } = event;
    const newValue = [...otpCode];
    newValue[index] = target.value;
    if (target.value.match(patternPerBox) || !target.value) {
      setOtpCode(newValue.join(''));
    }
  };

  const handleKeyUp = (event) => {
    if (event.key.match(patternPerBox) || event.key === 'ArrowRight') {
      const { target: { nextSibling } } = event;
      if (nextSibling) {
        nextSibling.focus();
      }
    }

    if (event.key === 'Backspace' || event.key === 'ArrowLeft') {
      const { target: { previousSibling } } = event;
      if (previousSibling) {
        previousSibling.focus();
      }
    }
  };

  const handleFocus = (event) => {
    event.target.select();
  };

  const handlePaste = (event) => {
    const dataToPaste = (event.clipboardData || window.clipboardData)
      .getData('text');

    const pattern = patternPerBox.source.replace(/[[\]]/g, '');
    const notValidCharacters = new RegExp(`[^${pattern}]`, 'g');
    const validDataToPaste = dataToPaste.replace(notValidCharacters, '')
      .slice(0, length);
    setOtpCode(validDataToPaste);
  };

  const inputKeys = [
    'digit-1', 'digit-2', 'digit-3', 'digit-4', 'digit-5', 'digit-6',
  ];

  return (
    <div className="otp-input-container">
      {otpInputs.map((_, index) => (
        <OtpInput
          key={inputKeys[index]}
          data-error={!!otpError}
          maxLength={1}
          onChange={handleChange(index)}
          onFocus={handleFocus}
          onKeyUp={handleKeyUp}
          onPaste={handlePaste}
          pattern={patternPerBox.source}
          value={otpCode[index] || ''}
        />
      ))}
    </div>
  );
};

export { OtpInputContainer };
